import React, { useEffect, useState } from 'react';
import leftarrow from '../../../assets/repayment/leftarrow.svg';
import { useAuthStore } from '../../../redux';
import { useNavigate } from 'react-router';
import { FullScreenBackdropLoader } from '../../../fibe-ui';
import submitNachCancellationRequestAPICall from '../helpers/submit-nach-cancellation-request';

const ReasonForMandateCancellation = () => {
  const navigate = useNavigate();
  const { customerId, customerRefNum, Authorization } = useAuthStore();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [otherReasonInput, setOtherReasonInput] = useState('');
  const [cancelReason, setCancelReason] = useState('');

  const proceedToCancelMandateClickHandler = () => {
    setIsLoading(true);
    submitNachCancellationRequestAPICall({
      customerCredentials: {
        customerId,
        customerRefNum,
        Authorization,
      },
      payload: {
        customerRefNum,
        repaymentRequest: {
          transactionType: 'emandateCancel',
          cancelReason,
        },
      },
      successFn: (res) => {
        console.log('Submit nach cancellation API call', res);
        const { statusCode, statusMsg, statusDes } = res;
        if (statusCode === 200) {
          navigate('/nach-cancellation/submitted-request');
        } else {
          navigate('/nach-cancellation/technical-issue');
        }
      },
      errorFn: (err) => {
        console.log(err);
      },
      finallyFn: () => {
        setIsLoading(false);
      },
    });
  };

  const otherReasonTextHandler = (e) => {
    const newReasonStr = e.target.value.trim();
    setOtherReasonInput(newReasonStr);
    setCancelReason([`${reasonsStringArr[3]} - ${newReasonStr}`]);
  };

  const backButtonClickHandler = () => {
    navigate('/dashboard');
  };

  const checkboxClickHandler = (idx) => (e) => {
    setSelectedIndex(idx);
    setCancelReason([reasonsStringArr[idx]]);
    if (idx === 3) {
      console.log('otherReasonInput= ', otherReasonInput);
      setCancelReason([`${reasonsStringArr[idx]} - ${otherReasonInput}`]);
    }
  };

  const reasonsStringArr = [
    'I no longer use this bank account',
    'I prefer making due payments manually',
    'I am not interested in auto-payment facility',
    'Others (Please specify)',
  ];

  useEffect(() => {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event) {
      history.pushState(null, document.title, location.href);
    });
  }, []);

  return (
    <>
      <FullScreenBackdropLoader isLoading={isLoading} />
      {/* ReceivedTheNachCancellationRequest */}
      <div className="p-0 lg:p-6">
        <div className="flex items-center mb-0 lg:mb-5 p-4 lg:p-0 shadow-md lg:shadow-none">
          <img
            onClick={backButtonClickHandler}
            className="inline-block mr-4 w-[11px] hover:cursor-pointer"
            src={leftarrow}
            alt="leftarrow"
          />
          <span className="text-text-primary text-xl md:text-xl">
            Auto Debit
          </span>
        </div>

        <div className="px-4 pb-4 lg:p-0 mt-5 lg:mt-0">
          <div className="rounded-2xl border border-stroke p-5 lg:px-8 lg:py-7">
            <div className="text-text-primary text-xl">
              Reason for cancellation
            </div>

            <div className="text-text-secondary text-base mt-2 short1:mt-4">
              Please select the reason to cancel your Auto debit set up
            </div>

            <div className="mt-4 short1:mt-10">
              {reasonsStringArr.map((singleReason, idx) => (
                <label
                  id={idx}
                  key={idx}
                  htmlFor="check1"
                  className="iTrCheckBox  !text-[12px] short1:!text-base text-text-primary !mb-6 short1:!mb-8"
                  onClick={checkboxClickHandler(idx)}
                >
                  <input
                    type="checkbox"
                    className="checked:bg-blue-500 mt-[3px]"
                    name={idx}
                    checked={selectedIndex === idx}
                    onClick={checkboxClickHandler(idx)}
                  />
                  <span className="iTrCheckmark nachResonCheckbox"></span>
                  <span className="block ml-4 relative top-[7px] short1:top-[5px]">
                    {singleReason}
                  </span>
                </label>
              ))}

              {selectedIndex === 3 ? (
                <textarea
                  placeholder="Type text here"
                  className="rounded-lg border border-stroke p-2 h-14 short1:h-24 w-4/5 sm:w-80 ml-12 mt-2.5 resize-none"
                  onChange={otherReasonTextHandler}
                ></textarea>
              ) : (
                ''
              )}
            </div>

            <div className="p-4 lg:p-0 mt-6 lg:mt-10 absolute left-0 bottom-0 short1:bottom-14 lg:!bottom-0 w-full lg:relative">
              <div>
                <button
                  onClick={proceedToCancelMandateClickHandler}
                  className="hover:bg-teal-600 ease-out duration-500 transition-all bg-accent text-base border border-accent text-white font-medium p-3 text-center rounded-md shadow-md w-full lg:w-[190px] mr-0 lg:mr-4 mb-3 lg:mb-0"
                >
                  Proceed to cancel
                </button>

                <button
                  onClick={backButtonClickHandler}
                  className="hover:bg-teal-100 ease-out duration-500 transition-all bg-white text-base text-accent border border-transparent lg:border-accent font-medium p-3 text-center rounded-md shadow-none  lg:shadow-md w-full lg:w-[190px] mr-0 lg:mr-4 mb-3 lg:mb-0"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReasonForMandateCancellation;
